'use strict';

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _createReactClass = require('create-react-class');

var _createReactClass2 = _interopRequireDefault(_createReactClass);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Avatar = require('../../../Avatar'); /*
                                         Copyright 2015, 2016 OpenMarket Ltd
                                         
                                         Licensed under the Apache License, Version 2.0 (the "License");
                                         you may not use this file except in compliance with the License.
                                         You may obtain a copy of the License at
                                         
                                             http://www.apache.org/licenses/LICENSE-2.0
                                         
                                         Unless required by applicable law or agreed to in writing, software
                                         distributed under the License is distributed on an "AS IS" BASIS,
                                         WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
                                         See the License for the specific language governing permissions and
                                         limitations under the License.
                                         */

var sdk = require("../../../index");
var dispatcher = require("../../../dispatcher");

module.exports = (0, _createReactClass2.default)({
    displayName: 'MemberAvatar',

    propTypes: {
        member: _propTypes2.default.object,
        fallbackUserId: _propTypes2.default.string,
        width: _propTypes2.default.number,
        height: _propTypes2.default.number,
        resizeMethod: _propTypes2.default.string,
        // The onClick to give the avatar
        onClick: _propTypes2.default.func,
        // Whether the onClick of the avatar should be overriden to dispatch 'view_user'
        viewUserOnClick: _propTypes2.default.bool,
        title: _propTypes2.default.string
    },

    getDefaultProps: function getDefaultProps() {
        return {
            width: 40,
            height: 40,
            resizeMethod: 'crop',
            viewUserOnClick: false
        };
    },

    getInitialState: function getInitialState() {
        return this._getState(this.props);
    },

    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
        this.setState(this._getState(nextProps));
    },

    _getState: function _getState(props) {
        if (props.member) {
            return {
                name: props.member.name,
                title: props.title || props.member.userId,
                imageUrl: Avatar.avatarUrlForMember(props.member, props.width, props.height, props.resizeMethod)
            };
        } else if (props.fallbackUserId) {
            return {
                name: props.fallbackUserId,
                title: props.fallbackUserId
            };
        } else {
            console.error("MemberAvatar called somehow with null member or fallbackUserId");
        }
    },

    render: function render() {
        var _this = this;

        var BaseAvatar = sdk.getComponent("avatars.BaseAvatar");

        var _props = this.props,
            member = _props.member,
            fallbackUserId = _props.fallbackUserId,
            onClick = _props.onClick,
            viewUserOnClick = _props.viewUserOnClick,
            otherProps = (0, _objectWithoutProperties3.default)(_props, ['member', 'fallbackUserId', 'onClick', 'viewUserOnClick']);

        var userId = member ? member.userId : fallbackUserId;

        if (viewUserOnClick) {
            onClick = function onClick() {
                dispatcher.dispatch({
                    action: 'view_user',
                    member: _this.props.member
                });
            };
        }

        return _react2.default.createElement(BaseAvatar, (0, _extends3.default)({}, otherProps, { name: this.state.name, title: this.state.title,
            idName: userId, url: this.state.imageUrl, onClick: onClick }));
    }
});
//# sourceMappingURL=MemberAvatar.js.map